import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-xl font-heading font-bold text-foreground-950 whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
              萝
            </span>
            狗头萝莉视频
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50'
              }`}
            >
              首页
            </Link>

            <div className="relative group">
              <button className="px-4 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1">
                分类浏览
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-0 mt-1 w-48 bg-background-50 rounded-lg shadow-lg border border-background-200/70 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${cat.icon} text-base`}></i>
                    </span>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <Link
              to="/about"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer">
              <i className="ri-search-line text-foreground-700 text-lg"></i>
            </button>
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer">
              <i className="ri-notification-3-line text-foreground-700 text-lg"></i>
            </button>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
          >
            <i className={`text-xl text-foreground-700 ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 space-y-1">
            <Link
              to="/"
              className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50 transition-colors cursor-pointer"
            >
              首页
            </Link>
            <div className="px-4 py-2 text-xs font-medium text-foreground-400 uppercase tracking-wider">
              分类浏览
            </div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50 transition-colors cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-base`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50 transition-colors cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}